import { ServerConfig } from "@/config/config";
import { DeletedSale } from "@/models/base/deleted-sale";
import { Axios } from "@/utils/axios";
import { IGetResponse } from "@/utils/get-response";

export class DeletedSalesServiceClass {
	public readonly url = ServerConfig.host + "/deleted-sales";

	public async getDeletedSales(limit:number, offset:number, order:string, orderDirection:"ASC" | "DESC"):Promise<IGetResponse<DeletedSale>> {
		let result = await Axios.get(this.url, {params: {
			limit,
			offset,
			order,
			orderDirection
		}});
		return {
			records: result.data.records,
			data: ((result.data.data || []) as any[]).map(d=>new DeletedSale(d))
		};
	}

	public async searchDeletedSales(searchString:string, limit:number, offset:number, order:string, orderDirection:"ASC" | "DESC"):Promise<IGetResponse<DeletedSale>> {
		let result = await Axios.get(`${this.url}/search/${searchString}`, {params: {
			limit,
			offset,
			order,
			orderDirection
		}});
		return {
			records: result.data.records,
			data: ((result.data.data || []) as any[]).map(d=>new DeletedSale(d))
		};
	}

	public async deleteDeletedSale(id:number):Promise<void> {
		await Axios.delete(`${this.url}/${id}`);
	}
}

export const DeletedSalesService = new DeletedSalesServiceClass();